
/// <amd-module name="Search/Shared/Components/ExtendedSearchSection/index" />
export * from "./ExtendedSearchSection";
export * from "./ExtendedSearchSection.Props";
